// components/start-game-logic.js: M3-11 pure gating logic for the
// Start Game CTA. Extracted from StartGameButton.jsx so node:test
// (which doesn't transform JSX) can cover the truth table directly.

export const TOTAL_SEATS = 4;

/**
 * @param {{
 *   isHost: boolean,
 *   phase: 'waiting'|'starting'|'in_game',
 *   occupantCount: number,
 *   botFill: boolean,
 * }} ctx
 * @returns {{ enabled: boolean, reason: string }}
 */
export function evaluateStartGame({ isHost, phase, occupantCount, botFill }) {
  if (!isHost)                  return { enabled: false, reason: 'Only the host can start the game.' };
  if (phase !== 'waiting')      return { enabled: false, reason: 'Game already starting.' };
  if (occupantCount >= TOTAL_SEATS) return { enabled: true,  reason: '' };
  if (botFill)                  return { enabled: true,  reason: '' };
  return {
    enabled: false,
    reason: `Need ${TOTAL_SEATS - occupantCount} more ${TOTAL_SEATS - occupantCount === 1 ? 'player' : 'players'}, or turn on bot fill`,
  };
}

/**
 * B3b F3: the plain not-ready note beside Start Game. Empty when
 * everyone is ready (nothing to say); singular for exactly one.
 *
 * @param {number|null|undefined} notReadyCount
 * @returns {string}
 */
export function notReadyNote(notReadyCount) {
  if (typeof notReadyCount !== 'number' || !Number.isFinite(notReadyCount)) return '';
  if (notReadyCount <= 0) return '';
  if (notReadyCount === 1) return '1 player is not ready';
  return `${notReadyCount} players are not ready`;
}

export function countOtherNotReady(occupants) {
  return occupants.filter((occupant) => !occupant.is_you && !occupant.ready).length;
}
